// 구인시스템 라우트
import Dashboard from "views/Dashboard/Dashboard";
import JobPool from "views/Dashboard/JobPool";
import JobPostings from "views/Dashboard/JobPostings";
import JobPostingDetail from "views/Dashboard/JobPostings/JobPostingDetail";
import JobPostingForm from "views/Dashboard/JobPostings/JobPostingForm";
import Applications from "views/Dashboard/Applications";
import WorkHistory from "views/Dashboard/WorkHistory";
import WorkManagement from "views/Dashboard/WorkManagement";
import MyProfile from "views/Dashboard/MyProfile";
import Notifications from "views/Dashboard/Notifications";
import SMSManagement from "views/Dashboard/SMSManagement";
import AcademicSchedule from "views/Dashboard/AcademicSchedule";
import ScheduleManagement from "views/Dashboard/ScheduleManagement";
import ScheduleApplication from "views/Dashboard/ScheduleApplication";
import SemesterManagement from "views/Dashboard/SemesterManagement";
import SemesterDetail from "views/Dashboard/SemesterManagement/SemesterDetail";
import UserManagement from "views/Dashboard/UserManagement";
import SignIn from "views/Auth/SignIn.js";
import SignUp from "views/Auth/SignUp.js";

import {
  HomeIcon,
  StatsIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  CartIcon,
  CreditIcon,
} from "components/Icons/Icons";
import { ChatIcon, CalendarIcon, TimeIcon, EditIcon } from "@chakra-ui/icons";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "대시보드",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/job-postings",
    name: "구인 공고",
    icon: <DocumentIcon color="inherit" />,
    component: JobPostings,
    layout: "/admin",
  },
  {
    path: "/applications",
    name: "나의 지원",
    icon: <CartIcon color="inherit" />,
    component: Applications,
    layout: "/admin",
    userOnly: true, // 일반 회원 전용
  },
  {
    path: "/work-history",
    name: "근무 이력",
    icon: <StatsIcon color="inherit" />,
    component: WorkHistory,
    layout: "/admin",
    userOnly: true, // 일반 회원 전용
  },
  {
    path: "/job-pool",
    name: "구인 풀 관리",
    icon: <PersonIcon color="inherit" />,
    component: JobPool,
    layout: "/admin",
    adminOnly: true, // 관리자 전용
  },
  {
    path: "/work-management",
    name: "근무 관리",
    icon: <CreditIcon color="inherit" />,
    component: WorkManagement,
    layout: "/admin",
    adminOnly: true, // 관리자 전용
  },
  {
    path: "/academic-schedule",
    name: "학업시간표 관리",
    icon: <CalendarIcon color="inherit" />,
    component: AcademicSchedule,
    layout: "/admin",
    scheduleOnly: true, // 스케줄 권한 필요
  },
  {
    path: "/schedule-application",
    name: "근무스케줄 신청",
    icon: <TimeIcon color="inherit" />,
    component: ScheduleApplication,
    layout: "/admin",
    scheduleOnly: true, // 스케줄 권한 필요
  },
  {
    path: "/schedule-management",
    name: "근무스케줄 관리",
    icon: <EditIcon color="inherit" />,
    component: ScheduleManagement,
    layout: "/admin",
    adminOnly: true, // 관리자 전용
  },
  {
    path: "/semester-management",
    name: "학기/근무자 관리",
    icon: <CalendarIcon color="inherit" />,
    component: SemesterManagement,
    layout: "/admin",
    adminOnly: true, // 관리자 전용
  },
  {
    path: "/semester-management/:semesterId",
    component: SemesterDetail,
    layout: "/admin",
    redirect: true, // 사이드바에 표시하지 않음
    adminOnly: true,
  },
  {
    path: "/user-management",
    name: "사용자 관리",
    icon: <PersonIcon color="inherit" />,
    component: UserManagement,
    layout: "/admin",
    adminOnly: true, // 관리자 전용
  },
  // {
  //   path: "/notifications",
  //   name: "알림톡 관리",
  //   icon: <RocketIcon color="inherit" />,
  //   component: Notifications,
  //   layout: "/admin",
  //   adminOnly: true, // 관리자 전용
  // },
  {
    path: "/sms-management",
    name: "문자 발송",
    icon: <ChatIcon color="inherit" />,
    component: SMSManagement,
    layout: "/admin",
    adminOnly: true, // 관리자 전용
  },
  {
    path: "/my-profile",
    name: "내 프로필",
    icon: <PersonIcon color="inherit" />,
    component: MyProfile,
    layout: "/admin",
  },
];

// 별도 라우트 (사이드바에 표시 안됨)
export const hiddenRoutes = [
  {
    path: "/job-postings/create",
    component: JobPostingForm,
    layout: "/admin",
  },
  {
    path: "/job-postings/:id/edit",
    component: JobPostingForm,
    layout: "/admin",
  },
  {
    path: "/job-postings/:id",
    component: JobPostingDetail,
    layout: "/admin",
  },
];

// 인증 라우트 (사이드바에 표시 안됨)
export const authRoutes = [
  {
    path: "/signin",
    component: SignIn,
    layout: "/auth",
  },
  {
    path: "/signup",
    component: SignUp,
    layout: "/auth",
  },
];

export default dashRoutes;
